import { takeEvery, put, call } from 'redux-saga/effects';
import { npcLogConstant } from 'src/redux/actions/constant';
import npcLogService from 'src/services/apiServices/npcLogService/npcLogService';

function* reviewNpcEntry(action: any): any {
  try {
    yield put({ type: npcLogConstant.REVIEW_NPC_ENTRY_LOADER });
    const response = yield call(npcLogService.reviewNpcEntry, action.payload);
    if (response?.status === 200 || response?.status === 201) {
      yield put({
        type: npcLogConstant.REVIEW_NPC_ENTRY_SUCCESS,
        payload: { response: response.data, status: response?.status },
      });
    } else {
      throw response;
    }
  } catch (error: any) {
    yield put({
      type: npcLogConstant.REVIEW_NPC_ENTRY_FAILURE,
      payload: { response: error?.response?.data, status: error?.response?.status },
    });
  }
}

function* reviewNpcEntrySaga() {
  yield takeEvery(npcLogConstant.REVIEW_NPC_ENTRY_REQUEST, reviewNpcEntry);
}

export default reviewNpcEntrySaga;
